import React, { useState } from "react";
import { IDrawerStyles, useDrawerStyles } from "..";
import { Dialog, VfxLib } from "../..";
import { VfxDialogProps } from "../../dialog/vfxDialogProps";
import { DrawerProps } from "../drawer";
import { DrawerStyled } from "./drawerStyled";
import { DrawerActionButtonProps } from "./template/drawerTemplateButton";

export interface DrawerViewProps extends DrawerProps {
    title?: string;
    onCopy?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    onEdit?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    onDelete?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    onDeactivate?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    onCancel?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    controlStyles?: IDrawerStyles | undefined;
    showDeactivateOnHeader?: boolean | undefined;
    modalDialogProps?: VfxDialogProps | undefined;
}

const ComponentProps = (props: DrawerViewProps): DrawerProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.onEdit;
    delete componentProps.onCancel;
    delete componentProps.onDelete;
    delete componentProps.onDeactivate;
    delete componentProps.modalDialogProps;
    delete componentProps.showDeactivateOnHeader;
    delete componentProps.controlStyles;
    return componentProps;
};

export const DrawerView: React.FC<DrawerViewProps> = (props) => {
    const styles: IDrawerStyles = useDrawerStyles();
    const [showDialog, setShowDialog] = useState<boolean>(
        props.modalDialogProps?.open ?? false
    );

    const headerbuttons: DrawerActionButtonProps[] = [];

    if (props.onCopy) {
        headerbuttons.push(
            VfxLib.drawerActionButtons({ drawerStyles: styles, onClick: props.onCopy }).copy
        );
    }

    if (props.onEdit) {
        headerbuttons.push(
            VfxLib.drawerActionButtons({ drawerStyles: styles, onClick: props.onEdit }).edit
        );
    }

    headerbuttons.push(
        VfxLib.drawerActionButtons({ drawerStyles: styles, onClick: props.onHide }).close
    );

    const footerbuttons: DrawerActionButtonProps[] = [
        VfxLib.drawerActionButtons({ drawerStyles: styles, onClick: setAction(props.onDelete) }).delete,
        VfxLib.drawerActionButtons({ drawerStyles: styles, onClick: setAction(props.onDeactivate) }).deactivate,
        VfxLib.drawerActionButtons({ drawerStyles: styles, onClick: setAction(props.onCancel) }).cancel,
    ];

    function setAction(action: React.MouseEventHandler<HTMLButtonElement> | undefined): React.MouseEventHandler<HTMLButtonElement> | undefined {
        if (action == null) return undefined;
        if (props.modalDialogProps == null) return action;

        return (event: React.MouseEvent<HTMLButtonElement>) => {
            event.preventDefault();
            setShowDialog(true);
        };
    }

    if (props.onDeactivate !== undefined) {
        footerbuttons[1].onClick = (e: React.MouseEvent<HTMLButtonElement>) =>
            props.modalDialogProps ? setShowDialog(true) : props.onDeactivate?.(e);
    }

    if (props.showDeactivateOnHeader === true) {
        const deActivatebutton = footerbuttons[1];
        deActivatebutton.display_type = "image-only";
        headerbuttons.splice(1, 0, deActivatebutton);
        footerbuttons.splice(1, 1);
    }

    return (
        <>
            <DrawerStyled
                {...ComponentProps(props)}
                headerbuttons={headerbuttons}
                footerbuttons={footerbuttons}
            />

            {props.modalDialogProps && (
                <Dialog
                    //contentText={props.modalDialogProps.contentText}
                    //contentTitle={props.modalDialogProps.contentTitle}
                    {...props.modalDialogProps}
                    onClose={() => setShowDialog(false)}
                    onConfirm={() => {
                        setShowDialog(false);
                        props.modalDialogProps?.onConfirm();
                    }}
                    open={showDialog}
                //closeText={props.modalDialogProps.closeText}
                //confirmText={props.modalDialogProps.confirmText}
                />
            )}
        </>
    );
};